import * as React from 'react';
import { useParams } from 'react-router-dom';
import { CustomForm } from '../../../amorg-common';
import { getCustomFormAnonymous, getCustomFormAnswer } from '../../../api/customFormClientApi';
import { Button } from '../../../designSystem/button/Button';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { P } from '../../../designSystem/typography/Body';
import { PublicPageWrapper } from '../../_pageWrappers/PublicPageWrapper';
import { CustomFormAnswerSubmissionPanel } from '../_components/CustomFormAnswerSubmissionPanel';



export function CustomFormSubmitAnswerPublicPage (): JSX.Element
{
    const params = useParams<{ siteId: string, answerId: string; }>();

    const [state, setState] = React.useState<{
        loading: boolean,
        title: string,
        form: CustomForm | null,
        done: boolean;
    }>({
        loading: true,
        title: 'Du er inviteret til at deltage i en undersøgelse',
        form: null,
        done: false
    });

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            if(!params.siteId || !params.answerId) return;

            const answer = await getCustomFormAnswer(params.answerId, params.siteId);
            if(!answer) return;
            const form = await getCustomFormAnonymous(answer.formId, params.siteId);
            if(!form) return;
            setState({ ...state, form, loading: false });
        };
        getData();
    }, [params.siteId, params.answerId]);


    return (

        <PublicPageWrapper siteId={params.siteId}>

                <PageHeader headerText={state.title} narrow />

                <SingleColumnLayout narrow>
                    <>
                        <LoadingPageOverlay loading={state.loading} />

                        {params.siteId && params.answerId && !state.done && state.form &&
                            <>
                                <CustomFormAnswerSubmissionPanel
                                    siteId={params.siteId} form={state.form} answerId={params.answerId} disableAnswerComponents={false} />

                                <Button variant="filled" size={"42px"} text="Afslut besvarelsen"
                                    onClick={() => setState({ ...state, done: true, title: 'Besvarelsen er afsluttet' })} />
                            </>
                        }

                        {state.done &&
                            <EndSubmission />
                        }

                    </>
                </SingleColumnLayout>

        </PublicPageWrapper>
    );
}


function EndSubmission (): JSX.Element
{
    return (
        <article>
            <P verticalMargin='40px'>
                Tak for din besvarelse!<br />
                <br />
                Den er nu sendt og kan ses af din arbejdsmiljørepræsentant og CRECEAs eksperter.<br />
                Kontakt din arbejdsmiljørepræsentant, hvis du har brug for mere information.<br />
                <br />
                Du kan nu lukke siden.
            </P>
        </article>
    );
}